export const DUTIES_STAMP = "CORE RESPONSIBILITIES";

export const DUTIES_SCAN_PILLS = [
  { value: "24/7", label: "Always on shift" },
  { value: "15 Q", label: "Smart intake" },
  { value: "LIVE", label: "Real calendar bookings" },
];

export const DUTIES_HEADLINE = {
  lead: "Your Digital Assistant's",
  accent: "Core Responsibilities",
};

export const DUTIES_SUBHEAD =
  "Everything a great office manager does — without the salary, sick days, or 5 PM cutoff.";

export const DUTIES_PHASES = [
  {
    id: "intake",
    phase: "01",
    label: "INTAKE",
    tagline: "Capture every lead",
    duties: [
      {
        title: "Greets & qualifies every lead",
        detail: "Branded welcome, up to 15 smart questions, returning customer fast-track",
      },
      {
        title: "Knows your services & area",
        detail: "Validates suburb, travel radius, declines out-of-scope jobs politely",
      },
    ],
  },
  {
    id: "trust",
    phase: "02",
    label: "TRUST",
    tagline: "Answer before they bounce",
    duties: [
      {
        title: "Pricing & trust questions",
        detail: "Ballpark ranges, licences, warranty — never invents facts",
      },
      {
        title: "Photos & job details",
        detail: "Guides what to photograph, gates booking when photos required",
      },
    ],
  },
  {
    id: "book",
    phase: "03",
    label: "BOOK",
    tagline: "Fills your calendar",
    highlight: true,
    duties: [
      {
        title: "Books real appointments",
        detail: "Live GHL or Google Calendar slots, natural language times",
      },
      {
        title: "Weather & safety checks",
        detail: "Blocks outdoor bookings in heavy rain or after dark",
      },
    ],
  },
  {
    id: "handoff",
    phase: "04",
    label: "HANDOFF",
    tagline: "You step in when needed",
    duties: [
      {
        title: "Emergencies & complex cases",
        detail: "Routes active emergencies to on-call; complex quotes to your team",
      },
      {
        title: "CRM updates & alerts",
        detail: "Funnel tracking, conversation summaries, instant notifications",
      },
    ],
  },
];

export const HONEST_LIMITS = {
  lead: "Does not replace an on-site inspection or guarantee a final quote without seeing the roof.",
  close: "When your expertise is needed, you step in instantly — with full conversation history preserved.",
};

export const ACCORDION_TOGGLE_LABEL = "Full capability index";

export const ACCORDION_GROUPS = [
  {
    title: "Lead capture and intake",
    items: [
      "Smart extraction from long customer messages",
      "Structured issue summary for estimators",
      "Verbal returning-customer recognition",
    ],
  },
  {
    title: "Booking and operations",
    items: [
      "On-site inspection vs phone callback modes",
      "Crew and appointment-type routing",
      "Minimum lead time, Friday ban, operating hours",
      "Holiday surcharges and callout fee math at booking time",
      "Weekend auto-confirm or pending-review rules",
      "Manager callback fallback when calendar unavailable",
    ],
  },
  {
    title: "Risk and trust",
    items: [
      "Height, asbestos, tenant, and commercial disqualification",
      "After-hours emergency direct dial",
      "Human takeover without losing chat history",
      "No false booking confirmations",
    ],
  },
  {
    title: "Channels and quality",
    items: [
      "GoHighLevel, WhatsApp, and Telegram delivery",
      "CRM opportunity conversation summary for staff",
      "Configurable tone of voice and emoji budget",
      "Anti-repetition and forbidden-phrase controls",
    ],
  },
];
